import React from 'react'

const SvgVideoOffFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.707 2.293a1 1 0 00-1.414 1.414l.535.56C2.276 4.577 2 5.16 2 6.017v11.988c0 1.334.67 2 2.014 2h10.985c.97 0 1.586-.353 1.851-1.057l2.65 2.774a1 1 0 101.414-1.414L3.707 2.293zM6 15.01h4c.666-.007 1 .325 1 .995 0 .67-.334 1.005-1 1.005H6c-.667 0-1-.335-1-1.005 0-.67.333-1.002 1-.995zM8.1 4c2.65-.001 5.682 0 6.896.005 1.335.005 2.004.67 2.004 2v3.008l3.402-1.203c.506-.176.898-.176 1.175 0 .278.176.42.476.422.9v6.677c.018.354-.123.62-.421.797-.299.177-.645.207-1.04.09l-.965-.346a1 1 0 01-.387-.253L8.1 4z'
    />
  </svg>
)

export default SvgVideoOffFilled
